export const MODULES = [
	{
		label: 'Usuários',
		key: 'users',
		checked: false,
	},
	{
		label: 'Permissões',
		key: 'permissions',
		checked: false,
	},
	{
		label: 'Menus',
		key: 'menu',
		checked: false,
	},
	{
		label: 'Notícias',
		key: 'news',
		checked: false,
	},
	{
		label: 'Torneios',
		key: 'tournaments',
		checked: false,
	},
	{
		label: 'Manchetes',
		key: 'featurednews',
		checked: false,
	},
	{
		label: 'Vídeos',
		key: 'videos',
		checked: false,
	},
];
